import { Text } from "@mantine/core";

export default function ShortcutHint({ label }) {
  return (
    <Text
      size="xs"
      color="dimmed"
      sx={{
        fontFamily: "monospace",
        
        
        padding: "2px 6px",
      }}
    >
      {label}
    </Text>
  );
}
